/**
 * The key-signature display setting: scales written under their key signature
 * (Show, the default) or with no key signature, every accidental on its note
 * (Accidentals only). Only the drawn notation changes; the notes a scale sounds,
 * and the take record's score, are the same either way.
 */

import {
  DEFAULT_KEY_SIGNATURE_DISPLAY,
  KEY_SIGNATURE_DISPLAYS,
  type KeySignatureDisplay,
} from 'Seeds/ExerciseContent/scaleNotation';

export const KEY_SIGNATURE_DISPLAY_LABELS: Record<KeySignatureDisplay, string> = {
  show: 'Show',
  accidentals_only: 'Accidentals only',
};

export const isKeySignatureDisplay = (value: unknown): value is KeySignatureDisplay =>
  typeof value === 'string' && KEY_SIGNATURE_DISPLAYS.includes(value as KeySignatureDisplay);

/** The setting from anything read back from storage: the default when unreadable. */
export const normalizeKeySignatureDisplay = (raw: unknown): KeySignatureDisplay =>
  isKeySignatureDisplay(raw) ? raw : DEFAULT_KEY_SIGNATURE_DISPLAY;
